/* eslint-disable jsx-a11y/anchor-is-valid */
import { BackgroundLogin } from "../components/BackgroundLogin";
import { ButtonLogin } from "../components/ButtonLogin";

import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useAuth } from "../../../context/useAuth";

import '../styles/styles.css';
import { useState } from "react";
import { Spinner } from "../../../shared/components/Spinner";
import { URLS } from "../../../infra/URLS";
import { Logo } from "../../../shared/Icons/Logo";

type LoginProps = {
  password: string;
  username: string;
};

export function Login() {
  const [isLoading, setIsLoading] = useState(false);
  const { register, handleSubmit } = useForm<LoginProps>();

  const auth = useAuth();
  const navigate = useNavigate();

  async function onFinish(data: { username: string; password: string; }) {
    try {
      setIsLoading(!isLoading);
      await auth.authenticated(data.username, data.password);
      navigate(URLS.DASHBOARD);
    } catch (err) {
        setIsLoading(isLoading);
    }
  }

  return (
    <div className="flex font-sans w-screen h-screen">
      <BackgroundLogin />
      <div className="flex relative items-center justify-center w-screen">
        <form className="space-y-6 w-80" onSubmit={handleSubmit(onFinish)}>
          <Logo />
          <div className="input-login-container">
            <div className="mt-[3rem]">
              <input
                type="text"
                {...register("username")}
                name="username"
                placeholder="Username"
                maxLength={50}
                className="input-login-style"
                pattern="[a-zA-Z0-9]+"
              />
            </div>
            <div>
              <input
                {...register("password")}
                name="password"
                type="password"
                placeholder="Senha"
                minLength={4}
                maxLength={18}
                className="input-login-style"
              />
            </div>

          </div>
          <div className="checkbox-login-style">
            <ButtonLogin type="submit">
              {!isLoading ? 'Entrar' : <Spinner />}
            </ButtonLogin>
          </div>

        </form>
      </div>
    </div>
  );
}
